import '.ej{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ek{padding-left:1.5rem;}.ssr-plugin'
import '.el{margin:1rem 0;}.ssr-plugin'
import '.em{color:var(--gray-700);}.ssr-plugin'
import '.en{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ej ek el em en"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
